// Currently Using CLIENT: YLJ

// Client-specific feature toggles ("YES" / "NO")

// Shows the Commission input on the Purchase Order form.
// The commission is info only (not part of the PO total) and is posted
// as a For-Approval expense once the PO is approved.
export const Payable_Commission = "YES";

export const isEnabled = (flag) => String(flag).toUpperCase() === "YES";
